import { useQuery } from '@apollo/client'
import { useMockExamsPlatformQuery } from 'resources/mock-exams-platform/use-mock-exams-platform-query'
import { FEATURED_STATS_QUERY, USER_TOTAL_SIMULATEDS_QUERY } from './graphql'
import { safelyGetFields, featuredTypes } from 'resources'
import { evolve } from 'ramda'

export const useFeaturedStats = () => {
  const { data: featuredData, loading: featuredLoading, error: featuredError, refetch: featuredRefetch } = useQuery(FEATURED_STATS_QUERY)
  const { data: simulatedData, loading: simulatedLoading, error: simulatedError, refetch: simulatedRefetch } = useMockExamsPlatformQuery(USER_TOTAL_SIMULATEDS_QUERY)

  const userTotalSimulateds = safelyGetFields(['userTotalSimulateds'], simulatedData)

  const featuredStats = safelyGetFields(['stats', 'featuredStats'], featuredData)
    .map(evolve({ type: type => featuredTypes[type] }))
    .map((item) => {
      if (item.type === featuredTypes.FINISHED_SIMULATEDS) {
        return {
          ...item,
          resolved: userTotalSimulateds != null ? userTotalSimulateds : item.resolved,
        }
      }

      return item
    })

  return {
    featuredStats,
    loading: featuredLoading || simulatedLoading,
    error: featuredError || simulatedError,
    refetch: () => {
      featuredRefetch()
      simulatedRefetch()
    },
  }
}
